// src/generators/dzial2_algebra/temat5_zadania_uzupelniajace_maturalne/
// podtemat3_maturalne_otwarte_types/MaturaPercentLinearSystemBusinessOpenTask.js
//
// Nowy plik typu zadania:
// - marketing / IT jako osobne zadanie
// - wykorzystuje wspĂłlnÄ… logikÄ™ z MaturaPercentLinearSystemOpenTask

import {
  generateTask as generateBaseTask,
  renderTask as renderBaseTask,
  renderInput as renderBaseInput,
  renderUserAnswer as renderBaseUserAnswer,
  renderAnswer as renderBaseAnswer,
  checkAnswer as checkBaseAnswer,
  renderExplanation as renderBaseExplanation,
} from "./MaturaPercentLinearSystemOpenTask";

function generateMay2025OriginalTask() {
  return {
    type: "MaturaPercentLinearSystemBusinessOpenTask",
    source: {
      variant: "original",
      exam: "MATURA",
      session: "2025_MAJ",
      taskNumber: 9,
    },
    data: {
      scenario: {
        id: "researchBudget",
        title: "Budżet na projekty badawcze",
        objectTotal: "zł",
        item1: "zespołowi A",
        item2: "zespołowi B",
        contextIntro:
          "Zarząd firmy wydzielił z budżetu kwotę łącznie na projekty badawcze dla dwóch zespołów: A i B. Łącznie przydzielono",
        questionPrefix: "Oblicz kwotę przyznaną",
        questionObject: "zespołowi A na realizację projektu badawczego.",
        answerNoun: "zł",
      },
      totalInitial: 1200000,
      p1: 13,
      p2: 11,
      r: 0,
      a1: 0.87,
      a2: 0.89,
      kRatio: 0,
      xCorrect: 735000,
      yCorrect: 465000,
      usedTotal: 146700,
      maxPoints: 2,
    },
  };
}

export function generateTask(options = {}) {
  if (options.variant === "original" && options.session === "2025_MAJ") {
    return generateMay2025OriginalTask();
  }

  // Zadanie 6: losujemy między dwoma kontekstami biznesowymi:
  // - marketing
  // - budżet na projekty badawcze
  // Skala "milion + setki tysięcy", a obliczenia dają kwoty bez części setnych.
  const scenarioId = Math.random() < 0.5 ? "marketing" : "researchBudget";

  const task = generateBaseTask({
    scenarioId,
    minTotal: 100,   // po skalowaniu => 1 000 000
    maxTotal: 190,   // po skalowaniu => 1 900 000
    scaleFactor: 10000,
  });
  return {
    ...task,
    type: "MaturaPercentLinearSystemBusinessOpenTask",
    source: { variant: "random", basedOn: "MATURA_2025_MAJ_9" },
  };
}

export function renderTask(task) {
  return renderBaseTask(task);
}

export function renderInput(task, userAnswer, onChange, disabled) {
  return renderBaseInput(task, userAnswer, onChange, disabled);
}

export function renderUserAnswer(userAnswer, task) {
  return renderBaseUserAnswer(userAnswer, task);
}

export function renderAnswer(task) {
  return renderBaseAnswer(task);
}

export function checkAnswer(task, userAnswer) {
  return checkBaseAnswer(task, userAnswer);
}

export function renderExplanation(task) {
  return renderBaseExplanation(task);
}

